import { useState, useEffect, useContext } from 'react';
import { Box } from '@mui/material';
import { Context } from '../../context';
// components
import AccountTabs from './AccountTabs';
// ----------------------------------------------------------------------

export default function AccountForm() {
  const { user } = useContext(Context);
  const { userDetail } = user;
  
  return (
    <Box sx={{ width: '100%' }}>
      <AccountTabs userDetail={userDetail}/>
    </Box>
  );
}
